import type { Api } from "@/api/types";

import { useApiClient } from "../ApiClientProvider";

export function useApi(): Api<null>["api"] {
  const apiClient = useApiClient();

  return apiClient.api.api;
}
